import { render } from "./remove-attachment.vue?vue&type=template&id=18061106&ts=true"
import script from "./remove-attachment.vue?vue&type=script&lang=ts"
export * from "./remove-attachment.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__